import { render, staticRenderFns } from "./CheckboxElement.vue?vue&type=template&id=bf729576&"
import script from "./CheckboxElement.vue?vue&type=script&lang=ts&"
export * from "./CheckboxElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports